import React from "react";

const decimalSeparator = (() => {
  if (
    typeof window !== "undefined" &&
    window.___APP_CONFIG___ &&
    window.___APP_CONFIG___.DECIMAL_SEPARATOR == "."
  )
    return ".";
  return ",";
})();

const thousandSeparator = (() => {
  if (
    typeof window !== "undefined" &&
    window.___APP_CONFIG___ &&
    window.___APP_CONFIG___.DECIMAL_SEPARATOR == "."
  )
    return ",";
  return ".";
})();

const currency =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.CURRENCY
    : "2";

const price =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PRICE
    : "4";

const quantity =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.QUANTITY
    : "8";

const percentage =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PERCENTAGE
    : "2";

const defaultValue =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.DEFAULT
    : "8";

const decimalAmount = {
  quantity: quantity,
  price: price,
  currency: currency,
  percentage: percentage,
  default: defaultValue,
};

export const formattedNumber = (
  value,
  dataTypeDecimalName = "default",
  decimalScale = null,
  removeZeros
) => {
  dataTypeDecimalName = dataTypeDecimalName.toString().toLowerCase().trim();

  if (decimalAmount[dataTypeDecimalName] === undefined) {
    dataTypeDecimalName = "default";
  }

  removeZeros = true;

  if (value === null || value === undefined || value === "") return "";

  if (
    typeof value === "string" &&
    (value.includes("-") || value.includes("/") || value.includes("T"))
  ) {
    const dateValue = new Date(value);
  
    if (!isNaN(dateValue.getTime())) {
      return dateValue.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    }
  }

  const normalizeNumericValue = (value) => {
    if (value === null || value === undefined || value === "") return null;
  
    if (typeof value === "number") return value;
  
    if (typeof value !== "string") return NaN;
  
    let normalized = value.trim();
  
    if (!normalized) return null;
  
    // Si usa formato 1.234,56 => sacar miles y cambiar coma por punto
    if (normalized.includes(".") && normalized.includes(",")) {
      if (normalized.lastIndexOf(",") > normalized.lastIndexOf(".")) {
        normalized = normalized.replace(/\./g, "").replace(",", ".");
      } else {
        normalized = normalized.replace(/,/g, "");
      }
    } else if (normalized.includes(",")) {
      // Si solo tiene coma, asumir decimal
      normalized = normalized.replace(",", ".");
    }
  
    return Number(normalized);
  };

  const numericValue = normalizeNumericValue(value);

  if (numericValue === null) return "";
  if (isNaN(numericValue)) return value;

  let isNegative = numericValue < 0;
  let res = Math.abs(numericValue).toString();

  if (
    dataTypeDecimalName === "default" ||
    dataTypeDecimalName === "currency" ||
    dataTypeDecimalName === "quantity"
  ) {
    if (decimalScale != null) {
      res = Number(Math.abs(numericValue)).toFixed(decimalScale);
    } else {
      res = Number(Math.abs(numericValue)).toFixed(decimalAmount[dataTypeDecimalName]);
    }
  }

  const floatRes = parseFloat(res);

  if (res.includes(".")) {
    res = res.split(".");
    if (thousandSeparator === ".") {
      res = parseInt(res[0], 10).toLocaleString("es-ES") + decimalSeparator + res[1];
    } else {
      res = parseInt(res[0], 10).toLocaleString("en-US") + decimalSeparator + res[1];
    }
  } else {
    if (thousandSeparator === ".") {
      res = parseInt(res, 10).toLocaleString("es-ES");
    } else {
      res = parseInt(res, 10).toLocaleString("en-US");
    }
  }

  if (
    (res.includes(decimalSeparator) && res.split(decimalSeparator)[0].length === 4) ||
    (!res.includes(decimalSeparator) && res.length === 4)
  ) {
    res = res.split("")[0] + thousandSeparator + res.substr(1);
  }

  if (isNaN(floatRes)) return value;

  if (isNegative && floatRes !== 0 && !removeZeros) res = "-" + res;
  if (isNegative && floatRes !== 0 && removeZeros) res = "-" + removeZeroesInDecimals(res);
  if (!isNegative && removeZeros) return removeZeroesInDecimals(res);

  return res;
};

export const 
FormattedNumber = ({
  value,
  dataTypeDecimalName = "default",
  decimalScale = null,
  removeZeros,
}) => {
  removeZeros = true;
  return (
    <span>
      {formattedNumber(value, dataTypeDecimalName, decimalScale, removeZeros) == "NaN"
        ? "-"
        : formattedNumber(value, dataTypeDecimalName, decimalScale, removeZeros)}
    </span>
  );
};

export const removeZeroesInDecimals = (value) => {
  try {
    const regexString =
      decimalSeparator === ","
        ? /^([\d.]+)$|^([\d.]+)\,0*$|^([\d.]+\,[0-9]*?)0*$/
        : /^([\d,]+)$|^([\d,]+)\.0*$|^([\d,]+\.[0-9]*?)0*$/;

    return value.toString().replace(regexString, "$1$2$3");
  } catch (err) {
    return value;
  }
};
